"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.regexp.constructor");

var _defaults = _interopRequireDefault(require("./defaults"));

/**
 *
 * @param data 数据内容,如果为Object,则表示Set操作,会写入Cookies,如果为String则表示为Get操作,获取对应的Cookie
 * @param opt 扩展参数, 可以配置例如过期时间等
 *      expires: 100 * 24 * 3600,
 *      domain: false,
 *      path: '/',
 *      secure: https ? true : false
 *      高级参数
 *      nulltoremove: true,   //设置参数为null,移除Cookie
 *      autojson: true,
 *      autoencode: true,
 *      encode: function(str){ return encodeURIComponent(str); },
 *      decode: function(str){ return decodeURIComponent(str); },
 */
function expires(time) {
  var expireDate = time;

  if (!(expireDate instanceof Date)) {
    expireDate = new Date();
    expireDate.setTime(expireDate.getTime() + time * 1000);
  }

  return expireDate.toUTCString();
}

function cookies(data) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  opt = (0, _defaults.default)(opt, {
    autoencode: true,
    autojson: true,
    decode: decodeURIComponent,
    encode: encodeURIComponent,
    expires: 365 * 24 * 3600,
    fallback: false,
    nulltoremove: true,
    path: '/',
    secure: window.location.protocol === 'https:'
  });

  if (typeof data === 'string') {
    var value = (new RegExp("\\b".concat(data, "=([^;]+)")).exec(document.cookie) || [])[1];

    if (opt.autoencode) {
      value = opt.decode(value);
    }

    if (!opt.autojson) {
      return value;
    }

    var real;

    if (['{', '['].indexOf(value[0]) > -1) {
      try {
        real = JSON.parse(value);
      } catch (e) {
        real = value;
      }

      if (typeof real === 'undefined' && opt.fallback) {
        real = opt.fallback(data, opt);
      }

      return real;
    }

    return value;
  } // Set each of the cookies


  document.cookie = (0, _keys.default)(data).reduce(function (prev, key) {
    var value = data[key];
    var expired = value === void 0 || opt.nulltoremove && value === null;

    if (expired) {
      value = '';
    } else {
      if (opt.autojson && (0, _typeof2.default)(value) === 'object') {
        value = (0, _stringify.default)(value);
      }

      if (opt.autoencode) {
        value = opt.encode(value);
      }
    }

    var values = ["".concat(opt.encode(key), "=").concat(value)];

    if (opt.expires) {
      values.push("expires=".concat(expires(expired ? -10000 : opt.expires)));
    }

    if (opt.path) {
      values.push("path=".concat(opt.path));
    }

    if (opt.domain) {
      values.push("domain=".concat(opt.domain));
    }

    if (opt.secure) {
      values.push('secure');
    }

    var item = values.join(';');
    opt.test && opt.test(item);
    return prev + item;
  }, '');
}

cookies.default = cookies;
var _default = cookies;
exports.default = _default;
module.exports = exports["default"];